export enum ButtonVariant {
    SOLID = "solid",
    OUTLINE = "outline",
}

export enum Reviewers {
    IMDB = "imdb",
    ROTAN_TOMATO = "rotatanTomato",
    GOOGLE = "google",
}

export enum SearchVariant {
    LARGE = "large",
    SMALL = "small",
}

export enum HTTP_METHOD {
    GET = "GET",
    POST = "POST",
    PUT = "PUT",
    DELETE = "DELETE",
}

export enum DIMENSION_VALUE {
    CINEMA = "cinema",
    DAY = "day",
    WEEKEND = "weekend",
    WEEK = "week",
    REGION = "region",
}

export enum REGION_VALUE {
    OVERSEAS = "overseas",
    INDIA = "india",
    ALL = "worldwide",
}

export enum SCHEDULE {
    END_OF_OPENING_WEEKEND = "End Of Opening Weekend",
    OPENING_WEEKEND = "Opening Weekend",
}

export const RELATED_STAR_CAST: any = {
    Crew: "actor_name",
    Writers: "writer",
    Directors: "director",
    Singers: "playback_singer",
};

export enum SCHEDULE_OVERALL {
    WorldwideGross = "Worldwide collections Gross cr.",
    OverseasGross = "Overseas Gross cr.",
    IndiaNett = "India box office Nett cr.",
    IndiaGross = "India box office Gross cr.",
}

export enum TABLE_OR_ICON_TYPE {
    TABLE_VIEW = "table_view",
    ICON_VIEW = "icon_view",
}

export enum FILTER_UPI {
    VALUE = "value",
    VOLUME = "volume",
    BOTH = "both",
    AMOUNT = "amount",
    NETC_BANKS_LIVE_ON_NETC = "banks_live_on_netc",
    NETC_TAG_ISSUANCE = "tag_issuance",
    TOTAL_VOLUME = "total-volume",
    TOTAL_VALUE = "total-value",
}

export enum STATE_FILTER_WEATHER_TABLE {
    delhi = "Delhi NCR",
    BENGALURU = "Bengaluru",
}

export enum HeaderTab {
    UPI = "Payments",
    NETC = "Collections",
}

export enum EngagementType {
    LIKES = "likes",
    CLAPS = "claps",
    COMMENTS = "comments",
    SHARES = "shares",
    VIEWS = "views",
}

export enum Theme {
    DARK = "dark",
    LIGHT = "light",
}

export enum HeaderVariant {
    SOLID = "solid",
    OUTLINE = "outline",
}

export enum CommentaryVariant {
    LONG = "long",
    SHORT = "short",
    MEDIUM = "medium",
}

export enum EntityType {
    CRICKET = "cricket",
    FOOTBALL = "football",
    MOVIE = "movie",
}

export enum Tournament {
    IPL2024 = "ipl-2024",
    IPL2025 = "ipl-2025",
    CHAMPIONS_TROPHY = "champions-trophy-2025",
}

export enum MatchCardVariant {
    LIVE = "live",
    TODAY = "today",
    UPCOMING = "upcoming",
    RESULT = "result",
    STARTING_SOON = "starting_soon",
    ABANDONED = "abandoned",
    POSTPONED = "postponed",
}

export enum TournamentTabs {
    HIGHLIGHTS = "HIGHLIGHTS",
    PREDICTIONS = "PREDICTIONS",
    ALL_MATCHES = "ALL_MATCHES",
    LEADERBOARD = "LEADERBOARD",
    POINTS_TABLE = "POINTS_TABLE",
    SQUAD = "SQUAD",
}

export enum Card {
    CONDITION = "CONDITION",
    PITCH = "PITCH",
}
